// @feature-spec brain/vidmax/feature-specs/embed-edit.md
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { EmbedEditPage } from "./-EmbedEditPage"

const embedEditSearchSchema = z.object({
  videoId: z.string().optional(),
})

export const Route = createFileRoute("/embed/edit")({
  component: EmbedEditPage,
  validateSearch: embedEditSearchSchema,
})
